(function($)
{
    /**
	 * Extend the global orion object
	 */
    $.extend(true, orion, {
        api: {
            newsletter: {}
        }
    });

    var
        api = orion.api.newsletter,
        uri = '/api-newsletter';

    /**
	 * @return {Promise}
	 */
    function subscribeNewsletter(data)
    {
        console.log(data);
        var
            promise = $.ajax(uri + '/subscribe', {
                'cache': false,
                headers: {
                    'Accept': 'application/json'
                },
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(data),
                'method': 'PUT'
            });

        console.log(promise);

        return promise;
    }

    /**
	 * @return {Promise}
	 */
    function unsubscribeNewsletter(data)
    {
        console.log(data);
        var
            promise = $.ajax(uri + '/unsubscribe', {
                'cache': false,
                headers: {
                    'Accept': 'application/json'
                },
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(data),
                'method': 'PUT'
            });

        console.log(promise);

        return promise;
    }

    api.subscribeNewsletter   = subscribeNewsletter;
    api.unsubscribeNewsletter = unsubscribeNewsletter;
})(jQuery);
